import ModalPageWrapper from "../../components/global-layout/modal-page-wrapper";
import OpenPdfModal from "../../components/section/process/open-pdf-modal";

function OpenPdfModalWrapper({setIsPdfModalOpen,handleRefresh, processUpdated, siteConfigDetails, pdfOptions, isPdfLoading, setPdfLoading }: any) {
  return (
    <ModalPageWrapper>
      <div className="w-[41%] h-full bg-io-white dark:bg-io-black-15 ml-auto max-md:w-[85%]">
        <OpenPdfModal handleRefresh={handleRefresh} setIsPdfModalOpen={setIsPdfModalOpen} processUpdated={processUpdated} siteConfigDetails={siteConfigDetails} pdfOptions={pdfOptions} isPdfLoading={isPdfLoading} setPdfLoading={setPdfLoading} />
      </div>
    </ModalPageWrapper>
  );
}
export default OpenPdfModalWrapper;
